<template>
<div class="contact-us-form">

  <div class="intro">
    <div class="content-block">
    </div>
    <div class="image-block"/>
  </div>


  <div v-if="submitStatus !== 'SUBMITTED'">

      <div class="icon-container container">
        <div class="row">
          <div class="icon col-sm">
            <img src="@/assets/Buildingicon.png" >
            Portland, OR
          </div>
          <div class="icon col-sm">
            <img src="@/assets/mailicon.png" >
            <a href="mailto:toer@talloaks.io">toer@talloaks.io</a>
          </div>
          <div class="icon col-sm">
            <img src="@/assets/phoneicon.png" >
            <a href="tel:9712664185">(971) 266-4185</a>
          </div>
        </div>
      </div>

      <form @submit.prevent="handleSubmit" class="contact-form">
        <div class="form-container container-fluid">
          <div class="row">
            <div class="col-sm form-group">
              <label for="name">Name</label>
              <input
                type="text"
                class="form-control"
                v-model="formData.name"
                :class="{
                  invalid: isValidName,
                  valid: isValidEmail }"
                id="name"
                aria-describedby="emailHelp"
                placeholder="Name">
            </div>
            <div class="col-sm form-group">
              <label for="email">Email</label>
              <span
                class="error"
                v-if="!isValidEmail">Please enter a valid email address</span>
              <input
                type="text"
                class="form-control"
                style="width:80%;"
                v-model="formData.email"
                id="email"
                :class="{
                  invalid: !isValidEmail,
                  valid: isValidEmail }"
                placeholder="user@example.com">
            </div>
          </div>

          <div class="row">
            <div class="col-sm form-group">
              <label for="timelineStart">Timeline (optional)</label>
              <div class="row">
                <div class="col-sm-5">
                  <input
                    type="date"
                    v-model="formData.timelineStart"
                    class="form-control"
                    id="timelineStart">
                </div>
                <span class="visible-sm">_</span>
                <div class="col-sm-5">
                  <input
                    type="date"
                    v-model="formData.timelineEnd"
                    class="form-control"
                    id="timelineEnd">
                </div>
              </div>
            </div>
            <div class="col-sm form-group">
              <div>
                <label for="budget">Budget</label>
                <span
                  class="error"
                  v-if="!isValidBudget">Please provide numeric amount</span>
              </div>
              <div class="form-control currency">
                $
                <input
                  type="text"
                  v-model="formData.budget"
                  :class="{
                    invalid: !isValidBudget,
                    valid: isValidBudget
                  }"
                  id="budget"
                  placeholder="0">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm form-group">
              <label for="description">Tell us a little about your project</label>
              <textarea
                class="form-control"
                rows="4"
                v-model="formData.description"
                id="description"
                placeholder="Details"/>
            </div>
          </div>

          <div class="row">
            <div
              class="col text-right">
              <span
                v-if="submitStatus === 'ERROR'"
                class="error">
                Unable to reach the server, please try again later.<br>
              </span>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="submitStatus === 'PENDING'">
                <img
                  v-if="submitStatus==='PENDING'"
                  class="ajax-spinner"
                  src="@/assets/ajax-loader.gif">
                <span v-else>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div
      v-if="submitStatus === 'SUBMITTED'"
      class="form-submitted">
      <h4>Thanks for your interest, we'll be in touch shortly!</h4>
    </div>
  </div>
</template>

<script>
//import { post } from '@/api';
import axios from 'axios';

export default {
  name: 'ContactUs',
  props: {},
  data() {
    return {
      formData: {
        email: null,
        timelineEnd: null,
        timelineStart: null,
        name: null,
        description: null,
        budget: '',
      },
      submitStatus: '',
    };
  },
  methods: {
    isValidEmail(){
      return true;
    },
    isValidBudget(){
      return true;
    },
    isValidName(){
      return true;
    },
    handleSubmit() {
        this.submitStatus = 'PENDING';
        axios.get('https://api.github.com/users/gregadams-toer', {
          validateStatus: status => status < 400,
        })
        .then(() => {
          this.submitStatus = 'SUBMITTED';
        })
        .catch(() => {
          this.submitStatus = 'ERROR';
        });
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables';

.contact-us-form {
  background-color: $content-color;

  form.contact-form {
    max-width: 1200px;
    margin: 0 auto;
  }
  .intro {
    flex-direction: row;
    height: 35vh;
    border-top:1px solid gray;
    border-bottom:1px solid gray;
  }

  .content-block {
    position: absolute;
    left: 0;
    top: 23%;
    width: 100%;
    text-align: center;
    color: $primary-color;
    z-index: 99;
  }

  .image-block {
    background-image: url(~@/assets/img/acornhand-cut.jpg);
    background-repeat: no-repeat;
    background-size: 120% 110%;
    background-position: bottom center;
    height: 100%;
    width:100%;
    z-index: 8;
  }

  .icon-container {
    text-align: center;
    img {
      margin:0 auto;
      width: 40px;
      margin-bottom: 1rem;
    }

    .icon {
      margin-bottom: 1.1rem;
    }
  }
  .form-container {
    // max-width: 80%;
    margin:0 auto;
  }

  .currency{
    display: inline-block;
    width:40%;

    input {
      border:none;
      outline:none;
      width: calc(100% - 15px);
    }
  }

  input[type="date"] {
    margin-bottom: 5px;
  }

  .icon-container,
  .form-container {
    padding:1rem;
  }

  button[type="submit"] {
    margin-left:auto;
  }

  .form-submitted {
    min-height: 20rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .ajax-spinner {
    display: inline;
  }
}

@media screen and (min-width: $break-sm) {
  .contact-us-form {
    .image-block {
      background-size: cover;
      background-position: bottom;
    }
    .form-container {
      width:80%;
    }

    .icon-container,
    .form-container {
      padding:2rem;
    }

    .icon img {
      height:50px;
      width:auto;
    }
  }
}

@media screen and (min-width: $break-md) {
  .contact-us-form {
    .image-block {
      background-size:100% 160%;
    }
  }
}
@media screen and (min-width: $break-lg) {
  .contact-us-form {
    .image-block {
      background-size:100% 200%;
      background-position: bottom -80px center;
    }
  }
}
@media screen and (min-width: $break-xl) {
  .contact-us-form {
    .intro {
      height: 40vh;
    }
    .image-block {
      background-size:100% 240%;
      background-position: bottom -120px center;
    }
  }
}
@media screen and (min-width: 1500px) {
  .contact-us-form {
    .intro {
      height: 45vh;
    }
    .image-block {
      background-size:100% 310%;
      background-position: bottom -210px center;
    }
  }
}
</style>
